import { Button, Responsive } from '@cian/ui-kit';
import { IconCommunicationMessage16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';
import { useOfferContext } from '../OfferContext';
import { useChatContext } from '../../context';

export function ChatButtonContainer() {
  const {
    author: { isChatsEnabled },
    tracking: { onChatButtonClick },
  } = useOfferContext();
  const { openChat } = useChatContext();

  const handleClick = React.useCallback(() => {
    openChat();
    onChatButtonClick();
  }, [onChatButtonClick, openChat]);

  if (!isChatsEnabled) {
    return null;
  }

  return (
    <>
      <Responsive desktop tablet>
        <Button
          onClick={handleClick}
          beforeIcon={<IconCommunicationMessage16 color="icon-main-default" />}
          theme="fill_secondary"
          data-name="ChatButton"
        />
      </Responsive>
      <Responsive phone>
        <Button onClick={handleClick} fullWidth size="M" theme="fill_secondary" data-name="ChatButton">
          Написать
        </Button>
      </Responsive>
    </>
  );
}
